import React from "react";

import TextWebComponent from "./TextWebComponent";
import RotatingGalleryWebComponent from "./RotatingGalleryWebComponent";
import PicCatalogWebComponent from "./PicCatalogWebComponent";

const WebComponent = (props) => {
  const { type, view, componentNumber, textColor } = props;
  // console.log("Rendering WebComponent");
  // console.dir(props);
  switch (type) {
    case "text":
      return <TextWebComponent {...view} componentNumber={componentNumber} />;
    case "rotatingImageGallery":
      return (
        <RotatingGalleryWebComponent
          {...view}
          componentNumber={componentNumber}
        />
      );
    case "pictureCatalog":
      return (
        <PicCatalogWebComponent
          {...view}
          componentNumber={componentNumber}
          textColor={textColor}
        />
      );
    default:
      return null;
  }
};

export default WebComponent;
